export default __webpack_public_path__ + "img/5.14e28b0e.jpg";